import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge muss unsere Schriftstufen kennen.
 *
 * Ohne diese Erweiterung war `cn("text-body-sm", "text-text-secondary")`
 * ein stiller Datenverlust: tailwind-merge kennt `text-body-sm` nicht
 * als Groesse, ordnet es deshalb der Textfarbe zu — und wirft es
 * als vermeintlichen Konflikt weg. Uebrig blieb die Farbe, die
 * Groesse fiel auf den Grundwert zurueck.
 *
 * Das passierte ueberall dort, wo Groesse und Farbe zusammen durch
 * `cn()` liefen, also in fast jeder Komponente — und es fiel nicht
 * auf, weil 14px Grundgroesse einer 13px-Stufe sehr aehnlich sieht.
 *
 * Wer eine Stufe in theme.css ergaenzt, ergaenzt sie auch hier.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "display-2xl",
            "display-xl",
            "display-lg",
            "heading-lg",
            "heading-md",
            "heading-sm",
            "body-lg",
            "body-md",
            "body-sm",
            "body-xs",
            "caption",
            "overline",
          ],
        },
      ],
    },
  },
});

/**
 * Klassen zusammenfuehren und Konflikte aufloesen — die spaetere
 * Utility gewinnt. Damit laesst sich jede Foundation-Komponente von
 * aussen ueberschreiben, ohne dass die Reihenfolge im Stylesheet
 * eine Rolle spielt.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
